import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  company: [],
  config: [],
  configurations: [],
  preferences: [],
  email: [],
  authenticate: [],
  sms: [],
};

export const settingsSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    setCompanySettings(state, action) {
      state.company = action.payload;
    },
    setConfigSettings(state, action) {
      state.config = action.payload;
    },
    setEmailSettings(state, action) {
      state.email = action.payload;
    },
    setAuthenticateSettings(state, action) {
      state.authenticate = action.payload;
    },
    setSmsSettings(state, action) {
      state.sms = action.payload;
    },
    setConfigurationsSettings(state, action) {
      state.configurations = action.payload;
    },
  },
});

export const {
  setCompanySettings,
  setConfigSettings,
  setEmailSettings,
  setAuthenticateSettings,
  setSmsSettings,
  setConfigurationsSettings,
} = settingsSlice.actions;

export default settingsSlice;
